import { Box } from '@material-ui/core';

import { LoanConditionsEntity } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/entities/LoanConditionsEntity';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';

export const CreditLineNoPurchase = ({ loanConditions }: { loanConditions: LoanConditionsEntity }) => {
  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <ReadOnlyDataRow labelTextId={'PRODUCT'} value={<Text tId={'NO_PURCHASE'} />} />
      </Box>
      <CustomDivider orientation={'horizontal'} margin={1} />
      <Box display={'flex'} flexDirection={'column'}>
        <ReadOnlyDataRow labelTextId={'CREDIT_LINE_AMOUNT'} value={loanConditions.principal} />
      </Box>
    </>
  );
};
